<template>
	<div>
		<i v-if="index == 1" class="icon iconfont iconzu611"></i>
		<i v-if="index == 2"  class="icon iconfont icontab_icon_font"></i>
		<i v-if="index == 3" class="icon iconfont iconzu611"></i>
	</div>
</template>

<script>
export default {
	data() {
		return{
			
		}
	},
	props: {
		index: {
			type: Number,
			default: 1
		}
	},
};
</script>

<style scoped>
	i:hover{
		
		color: rgba(255, 255, 255, 0.65);
	}
	i{
		font-size: 16px;
		color:#FFFFFF;
	}
</style>
